import { createAction, props } from '@ngrx/store';
import { IVoucher } from 'app/models/voucher';

export const clearAllItems = createAction('[DalHelper] Clear All Vouchers');

export const loadItem = createAction('[Module Component] Load Voucher', props<{ id: string }>());
export const loadItemSuccess = createAction('[Voucher API] Load Voucher Success', props<{ item: IVoucher }>());
export const loadItemFailure = createAction('[Voucher API] Load Voucher Failure', props<{ error: any }>());

export const loadItems = createAction('[Module Component] Load Vouchers', props<{ barId: string; forceRefresh?: boolean }>());
export const loadItemsSuccess = createAction('[Voucher API] Load Vouchers Success', props<{ items: IVoucher[] }>());
export const loadItemsFailure = createAction('[Voucher API] Load Vouchers Failure', props<{ error: any }>());


export const addVoucher = createAction('[Subscription Page] Add Voucher', props<{ code: string }>());
export const addVoucherSuccess = createAction('[Subscription API] Add Voucher Success', props<{ success: boolean }>());
export const addVoucherFailure = createAction('[Subscription API] Add Voucher Failure', props<{ error: any }>());
